export default {
  containerStyles: function (theme) {
    return {
      height: 75,
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.header
    };
  }
};